import { memo } from "react";
import { usePaidLinksModule } from "./hooks/usePaidLinksModule";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { FeedModuleTypeEnum } from "@/common/services/types";
import { AdCreators } from "../AdCreators";
import { FeedModuleContainer } from "@/components/player-feed/FeedModules/FeedModuleContainer";
import "./PaidLinksModule.scss";

interface IPaidLinksModule {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const PaidLinksModule = memo(({ moduleId, moduleType }: IPaidLinksModule) => {
  const isMobile = useDeviceType() !== deviceTypeEnum.DESKTOP;

  const { creators } = usePaidLinksModule(isMobile);

  if (!isMobile || !creators.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <AdCreators title="OnlyFans creators you might enjoy:" creators={creators} />
    </FeedModuleContainer>
  );
});
